import React, { useState } from "react";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { facultiesApi } from "../../../services/nomenclatures/facultiesApi";
import { studentsApi } from "../../../services/students/studentsApi";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import { specialitiesApi } from "../../../services/nomenclatures/specialitiesApi";
import { groupsApi } from "../../../services/nomenclatures/groupsApi";
import CustomDropdown from "../../../components/forms/CustomDropdown";

const GroupAverageGradeReport: React.FC = () => {
  const [facultyId, setFacultyId] = useState<number | null>(null);
  const [specialityId, setSpecialityId] = useState<number | null>(null);
  const [semester, setSemester] = useState<number>(1);

  const { data: faculties } = facultiesApi.useGetFacultiesQuery();
  const { data: specialities } = specialitiesApi.useGetSpecialitiesQuery();
  const { data: report, isFetching } = groupsApi.useGetGroupsAverageGradeReportQuery(
    { facultyId: facultyId!, specialityId, semester },
    { skip: !facultyId },
  );

  const semesters = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const exportToExcel = () => {
    if (!report?.data) return;

    const exportData = report.data.map((item) => ({
      Специалност: item.specialityName,
      Семестър: item.semester,
      Група: item.groupName,
      "Среден успех": item.averageGrade,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet["!autofilter"] = { ref: worksheet["!ref"] || "A1" };

    worksheet["!cols"] = [
      { wch: 30 }, // Специалност
      { wch: 10 }, // Семестър
      { wch: 10 }, // Група
      { wch: 20 }, // Среден успех
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Среден успех по групи");
    XLSX.writeFile(workbook, "справка-средни-успехи-по-групи.xlsx");
  };

  return (
    <div className="flex justify-content-center flex-wrap">
      <Card className="w-full mt-4">
        <div className="flex justify-content-between align-items-center">
          <h4>Справка за среден успех по групи</h4>
          <Button
            icon="pi pi-file-excel"
            label="Експорт"
            className="p-button-success"
            onClick={exportToExcel}
            disabled={!report?.data || isFetching}
          />
        </div>
        <Divider />
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-6">
            <label htmlFor="facultyId">Факултет</label>
            <Dropdown
              id="facultyId"
              options={faculties?.data ?? []}
              optionLabel="name"
              optionValue="facultyId"
              placeholder="Изберете факултет"
              value={facultyId}
              onChange={(e: DropdownChangeEvent) => setFacultyId(e.value)}
              required
              className="w-full"
            />
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="specialityId">Специалност</label>
            <Dropdown
              id="specialityId"
              options={specialities?.data.filter((s) => s.facultyId === facultyId) ?? []}
              optionLabel="name"
              optionValue="specialityId"
              placeholder="Изберете специалност"
              value={specialityId}
              onChange={(e: DropdownChangeEvent) => setSpecialityId(e.value)}
              required
              className="w-full"
            />
          </div>

          <div className="field col-12 md:col-6">
            <label htmlFor="semester">Семестър</label>
            <Dropdown
              id="semester"
              options={semesters}
              placeholder="Изберете семестър"
              value={semester}
              onChange={(e: DropdownChangeEvent) => setSemester(e.value)}
              required
              className="w-full"
            />
          </div>
          <div className="field col-12">
            <DataTable
              value={report?.data}
              loading={isFetching}
              emptyMessage="Няма намерени резултати"
              stripedRows
              paginator
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
            >
              <Column field="specialityName" header="Специалност" sortable />
              <Column field="semester" header="Семестър" sortable />
              <Column field="groupName" header="Група" sortable />
              <Column field="academicYearName" header="Академична година" sortable />
              <Column field="averageGrade" header="Среден успех" sortable />
            </DataTable>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default GroupAverageGradeReport;
